import { useQuery } from "@apollo/client"
import { at, get } from "lodash-es"
import React from "react"
import { useParams } from "react-router-dom"
import logo from "assets/images/logo_ios.png"
import ButtonLink from "components/Atoms/ButtonLink"
import CustomSpinner from "components/Atoms/CustomSpinner"
import Image from "components/Atoms/Image"
import Error from "components/Common/Error"
import TrackNavbar from "components/Track/TrackNavbar"
import KNOW_YOUR_FARMER from "graphql/track.graphql"

const TrackingPage = () => {
  const { id } = useParams()
  const { data, loading, error } = useQuery(KNOW_YOUR_FARMER, {
    variables: { id },
  })

  if (loading) return <CustomSpinner />
  if (error) return <Error />
  const kyf = get(data, "kyfDetails")
  const location = at(kyf.farmLocation, [
    "village",
    "taluka",
    "district",
    "state",
    "pincode",
  ]).filter(e => e)
  return (
    <div className="vt-track-screen">
      <TrackNavbar
        brand={kyf.organisationPhoto}
        brandName={kyf.organisationName}
        website={kyf?.organisationLink}
        email={kyf?.organisationEmail}
        contact={kyf?.organisationContact}
      />
      <div className="vt-track-content lg:py-5">
        <div className="container mt-lg-5 mt-md-3 mt-xs-2">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-6">
              <div className="vt-farmer-details">
                <h4>
                  <span className="highlight">{kyf.farmerName}</span>
                </h4>

                <Image
                  className="vt-farmer-image p-1 border rounded-md bg-white max-w-full h-auto"
                  src={
                    kyf.photo ? kyf.photo : "https://via.placeholder.com/1200"
                  }
                  description={kyf.farmerName}
                />
              </div>
            </div>
            <div className="col-span-6">
              <div className="vt-farm-details">
                <div className="vt-crop-details">
                  <h4>Crop Details</h4>

                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-4">Crop</div>
                    <div className="col-span-1 d-none d-lg-block">:</div>
                    <div className="col-span-7">
                      <span className="highlight">{kyf.varietyName}</span>
                    </div>
                  </div>
                </div>
                <hr className="my-4" />
                <div className="vt-plot-details">
                  <h4>Plot Details</h4>
                  <div className="plot-details">
                    <div className="grid grid-cols-12 gap-4">
                      <div className="col-span-4">Area</div>
                      <div className="col-span-1 d-none d-lg-block">:</div>
                      <div className="col-span-7">
                        <span className="highlight">
                          {kyf.farmArea || kyf.farmArea === 0
                            ? kyf.farmArea
                            : 0}{" "}
                          <small>Acres</small>{" "}
                        </span>
                      </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4">
                      <div className="col-span-4">Address</div>
                      <div className="col-span-1 d-none d-lg-block">:</div>
                      <div className="col-span-7">
                        <span className="highlight">{location.join(", ")}</span>
                      </div>
                    </div>

                    <ButtonLink
                      dark
                      className="mt-3"
                      href={`https://www.google.com/maps/search/?api=1&query=${get(
                        kyf,
                        "farmLocation.latitude"
                      )}%20${get(kyf, "farmLocation.longitude")}`}
                      icon="locate"
                      target="__blank"
                    >
                      View on Map
                    </ButtonLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="vt-track-footer w-full text-center">
        <span className="text-muted mr-6">Powered by </span>{" "}
        <a
          href="https://vesatogo.com/"
          target="__blank"
          className="vt-brand-link"
        >
          <Image
            className="vt-brand-image mr-2"
            src={logo}
            description="Vesatogo Innovations"
          />
          Vesatogo Innovations
        </a>
      </footer>
    </div>
  )
}

export default TrackingPage
